module.exports = __webpack_public_path__ + "static/media/icon-access-anywhere.5f4b8b3e.svg";